export const APP_NAME = "DR Company Research";

export const APP_HERO_SUBTITLE =
  "Realize due diligence aprofundada de empresas com tecnologia da Tavily";

export const NAV_ITEMS = [
  { to: "/", label: "Nova pesquisa", end: true },
  { to: "/history", label: "Histórico", end: false },
] as const;
